export const GenderValue = {
  MALE: 'Male',
  FEMALE: 'Female',
  OTHER: 'Other',
  DECLINED_TO_ANSWER: 'Declined to answer',
} as const;
